import script from "./SubArea.vue?vue&type=script&setup=true&lang=js"
export * from "./SubArea.vue?vue&type=script&setup=true&lang=js"

import "./SubArea.vue?vue&type=style&index=0&id=eb29bc6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb29bc6c"]])

export default __exports__